import { Button } from 'primereact/button';
import { Image } from 'primereact/image';
import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useRef } from 'react';
import ImgRender from './ImgRender';
import { fetchImageUrl } from '../utility/service/api-file';
import { SystemLoading,checkLoading } from '../store/loadingStore';

const ImagePDFComponent = ({ file,
  previewUrl,
  disabled = false,
  deleteImg,
  wrapperClass,
  wrapperStyle = {},
  imgWidth = '250',
  imgHeight = '250',
  zoomSrc=""
}) => {
  const imgRef = useRef(null)
  const { t } = useTranslation();
  const [,loading] = useContext(SystemLoading);


  const handlePDFLink = (url,fileName) => {
    checkLoading(loading);
    if(url?.startsWith('blob')){
      window.open(url, '_blank');
      checkLoading(loading,false);
    }else{
      fetchImageUrl({path:url},true)
      .then((pdfUrl)=>{
        checkLoading(loading,false);
        window.open(pdfUrl, '_blank');
      })
      .finally((fin)=>{
        checkLoading(loading,false);
      })
    }
    // if(url?.startsWith('blob')){ //還沒上傳前 由前端組成的短網址
    // window.open(url, '_blank');
  
    // }else{ //從後端取得的URL 檔案路徑另開分頁
    // const link = document.createElement('a');
    // // create a blobURI pointing to our Blob
    // link.href = url;
    // link.target = "_blank"
    // // link.download = fileName+'.pdf'; //需要download 再開啟
    // // some browser needs the anchor to be in the doc
    // document.body.append(link);
    // link.click();
    // link.remove();
    // // in case the Blob uses a lot of memory
    // setTimeout(() => URL.revokeObjectURL(link.href), 2000);
    // }

    
  }

  // console.log(file);
  return (<>
    <div className={wrapperClass} style={wrapperStyle}>
      {
        (file && previewUrl) && (
          <>
            {
              (file.type?.indexOf('pdf') > -1 || file.type?.indexOf('application') > -1) ? (
                <div className="custom-file-column">
                  <Link style={{wordBreak:'break-all'}} onClick={() => { handlePDFLink(previewUrl,file?.name) }}>{file?.name} {file?.name.indexOf('.')>-1?'':'.'+file?.type}</Link>
                  {
                    !disabled && (
                      <Button type='button' icon="pi pi-trash" className='p-button-icon-only ml-2' rounded text severity="danger" onClick={deleteImg}>
                      </Button>
                    )
                  }
                </div>
              ) : (<>
                {
                  previewUrl &&
                  <>
                  <ImgRender
                    imgPathSml={previewUrl}
                    imgRef={imgRef}
                    deleteImg = {deleteImg}
                    disabled={disabled}
                    imgPathZoom = {zoomSrc}
                    imgWidth={imgWidth}
                    imgHeight = {imgHeight}
                  />
                      {/* 可預覽 zoomSrc 大圖 src 小圖 */}
                    {/* <div className='custom-image-preview' style={{'--height': `${imgHeight}px`, '--width': `${imgWidth}px` }}>
                      <Image
                        zoomSrc={zoomSrc}
                        src={previewUrl}
                        alt="Image"
                        width={imgWidth}
                        height={imgHeight}
                        preview ref={imgRef}
                        className={disabled ? '' : 'original-preview-none'}
                      />
                       <div className='custom-image-edit-indicator'>
                            <Button
                             type='button'
                              icon="pi pi-eye"
                              className='p-button-icon-only' rounded text
                              onClick={() => imgRef.current?.show()}>
                            </Button>
                           
                      {
                        !disabled && (
                            <Button
                              type='button'
                              icon="pi pi-trash"
                              className='p-button-icon-only' rounded text
                              severity="danger"
                              onClick={deleteImg}>
                            </Button>
                          
                        )
                      }
                    </div>
                    </div> */}
                  </>
                }
              </>)
            }
          </>
        )
      }

      {/* {previewUrl} */}
      {/* {file?.size} */}
    </div>
  </>
  )
}

const EditPanel = () => {
  return (
    <div>
      123
    </div>
  )
}

export default ImagePDFComponent
